module.exports = __webpack_public_path__ + "static/media/VectorDownArrow.b09dd50b.svg";